import { WebRTC2, debugerNIMEventList } from '@/utils/NIM/index';
import { NIMEventLog } from '@/utils/sentry';

export interface Stream {
  getId: () => number;
  [k: string]: any;
}

interface Options {
  appKey: string;
  clientKey?: string;
  addStream?: (stream: Stream) => void;
  removeStream?: (stream: Stream) => void;
  activeSpeaker?: (data: Record<string, any>) => void;
  notAllowedError?: () => void;
}

const init = async (options: Options) => {
  //  clientKey = 'SIMULTANEOUS_INTERPRETING',
  const { appKey, addStream, removeStream, activeSpeaker, notAllowedError } = options;
  // 这里只是创建一个会话客户端， 之后需要加入到一个房间才能和远端通信
  const client = await WebRTC2.createClient({
    appkey: appKey, // 您的 appkey
    debug: process.env.NODE_ENV === 'development' ? false : true, // 是否开启调试日志
    report: true,
  });
  // WebRTC2.Logger?.enableLogUpload?.(true);
  // 有人停止发布自己的媒体流 即这个人调用了 unpublish 接口
  client.on('stream-removed', async (evt: any) => {
    const { stream } = evt;
    stream && (await stream.stop(evt?.mediaType));
    removeStream?.(stream);
  });

  // 有人发布了自己的媒体流 即这个人调用了 publish 接口
  // 可以通过 subscribe 进行订阅
  client.on('stream-added', async (evt: any) => {
    const { stream, mediaType } = evt;
    // const yxuid = stream.getId();
    stream.setSubscribeConfig({
      audio: true,
      video: false,
      screen: true,
    });
    // 音频自动播放
    if (mediaType === 'audio') {
      // 必须要订阅才可以推送播放，云信sdk需要这样做
      await client.subscribe(stream);
      await stream.play();
      await stream.isPlaying('audio');
    }
    addStream?.(stream);
    // EventEmitter.addListener(`${clientKey}-stream`, () => {
    // });
  });

  client.on('active-speaker', (data: any) => {
    console.warn('===== 当前在子频道讲话的人：', data.uid);
    activeSpeaker?.(data);
  });

  client.on('NotAllowedError', (error: any) => {
    const errorCode = error?.getCode?.() || error?.error?.getCode?.() || error?.error?.code;
    if (errorCode === 41030) {
      notAllowedError?.();
    }
  });
  debugerNIMEventList.forEach((eventStr) => {
    client.on(eventStr, (evt: any) => {
      const tagObj = { eventType: eventStr };
      NIMEventLog(tagObj, { data: evt, ...tagObj });
    });
  });
  // client.on('active-speaker', (data: any) => {});
  return client;
};

export { init };
